const deleteFrequency = {
  toastr: 'frequency deleted',
  toastr1: 'successfully deleted'
};

export default deleteFrequency;
